import React, { useState } from "react";
import PopUp, { closePopUp } from "../../../../../components/popUp";
import TextField from "../../../../../components/textField/textField";
import Button from "../../../../../components/button";
import { getUrlType, URLType } from "../../../../../utils/urlUtils";
import { PerformanceDTOTypeEnum } from "../../../../../openapi-generated-client";

interface EditPieceAddPerformancePopUpProps {
    onFinish: (url: string, type: PerformanceDTOTypeEnum) => void
}

export default function EditPieceAddPerformancePopUp(props: EditPieceAddPerformancePopUpProps) {

    const [url, setUrl] = useState("");
    const [error, setError] = useState("");

    return <PopUp title="Add Performance" className="medium">
        <TextField autoFocus label="Link" placeholder="URL..." onChange={(v) => {
            setUrl(v);
            setError("");
        }} value={url}/>
        <p className="error">{error}</p>
        <Button extraPadding thin onClick={() => {
            if(url.length == 0) {
                setError("Your url cannot be empty");
                return;
            }
            var type = getUrlType(url);
            if(type == null) {
                setError("Allowed are only: Spotify, Youtube & Soundcloud")
                return;
            }
            props.onFinish(url, type);
            closePopUp();
        }}>+ Add</Button>
    </PopUp>

}